// Author Eric
// Date 2021-06-07 16:53:40

class SithMesAndonTask {
constructor({
        id = null,
        code = '',
        problemAndonTypeId = '',
        problemAndonTypeName = '',
        problemAndonSubtypeId = '',
        problemAndonSubtypeName = '',
        handleAndonTypeId = '',
        handleAndonTypeName = '',
        andonLightLevelId = '',
        startTime = '',
        stopWork = '',
        status = '',
        expireNotice = '',
        mstPositionId = '',
        mstPositionName = '',
        mstLocationId = '',
        mstLocationName = '',
        handleUserId = '',
        handleUserIdLoginName = '',
        prdPpOperationId = '',
        prdPpOperationName = '',
        seq = '',
        problemDescription = '',
        problemAttachment = '',
        handleDescription = '',
        handleAttachment = '',
        responseTime = '',
        finishTime = '',
        remark = '',
        problemAttachmentList = '',
        handleAttachmentList = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.problemAndonTypeId = problemAndonTypeId;
    this.problemAndonTypeName = problemAndonTypeName;
    this.problemAndonSubtypeId = problemAndonSubtypeId;
    this.problemAndonSubtypeName = problemAndonSubtypeName;
    this.handleAndonTypeId = handleAndonTypeId;
    this.handleAndonTypeName = handleAndonTypeName;
    this.andonLightLevelId = andonLightLevelId;
    this.startTime = startTime;
    this.stopWork = stopWork;
    this.status = status;
    this.expireNotice = expireNotice;
    this.mstPositionId = mstPositionId;
    this.mstPositionName = mstPositionName;
    this.mstLocationId = mstLocationId;
    this.mstLocationName = mstLocationName;
    this.handleUserId = handleUserId;
    this.handleUserIdLoginName = handleUserIdLoginName;
    this.prdPpOperationId = prdPpOperationId;
    this.prdPpOperationName = prdPpOperationName;
    this.seq = seq;
    this.problemDescription = problemDescription;
    this.problemAttachment = problemAttachment;
    this.handleDescription = handleDescription;
    this.handleAttachment = handleAttachment;
    this.responseTime = responseTime;
    this.finishTime = finishTime;
    this.remark = remark;
    this.problemAttachmentList = problemAttachmentList;
    this.handleAttachmentList = handleAttachmentList;
}
}

function newEntity() {
return new SithMesAndonTask();
}

const dispatchVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.andon.sithMesAndonTask.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.andon.sithMesAndonTask.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.andon.sithMesAndonTask.grid.id',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstWorkCenterName',
        label: 'label.sith.andon.sithMesAndonTask.grid.mstWorkCenterName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.andon.sithMesAndonTask.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.andon.sithMesAndonTask.grid.createdByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.andon.sithMesAndonTask.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'problemAndonTypeName',
        label: 'label.sith.andon.sithMesAndonTask.grid.problemAndonTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'stopWork',
        label: 'label.sith.andon.sithMesAndonTask.grid.stopWork',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.andon.sithMesAndonTask.grid.startTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.sith.andon.sithMesAndonTask.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '未响应' },
                            { value: '2', text: '已响应' },
                            { value: '3', text: '已超时' },
                            { value: '4', text: '已完成' },
                            { value: '5', text: '已撤销' }
            ]
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.andon.sithMesAndonTask.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.andon.sithMesAndonTask.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpHeaderOrderCode',
        label: 'label.sith.andon.sithMesAndonTask.grid.prdPpHeaderOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationName',
        label: 'label.sith.andon.sithMesAndonTask.grid.prdPpOperationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.andon.sithMesAndonTask.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'handleUserIdName',
        label: 'label.sith.andon.sithMesAndonTask.grid.handleUserIdName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'problemAndonSubtypeName',
        label: 'label.sith.andon.sithMesAndonTask.grid.problemAndonSubtypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'handleAndonTypeName',
        label: 'label.sith.andon.sithMesAndonTask.grid.handleAndonTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'problemDescription',
        label: 'label.sith.andon.sithMesAndonTask.grid.problemDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'problemAttachmentList',
        label: 'label.sith.andon.sithMesAndonTask.grid.problemAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'handleDescription',
        label: 'label.sith.andon.sithMesAndonTask.grid.handleDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'handleAttachmentList',
        label: 'label.sith.andon.sithMesAndonTask.grid.handleAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'responseTime',
        label: 'label.sith.andon.sithMesAndonTask.grid.responseTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'finishTime',
        label: 'label.sith.andon.sithMesAndonTask.grid.finishTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonTask.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}
const executeVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.andon.sithMesAndonTask.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.andon.sithMesAndonTask.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ]

const filter = {
    idFilter : "",
    codeFilter : "",
    createdByNameFilter : "",
    mstLocationIdIsNullFilter : "",
    prdPpOperationIdIsNullFilter : "",
    problemAndonTypeIdFilter : "",
    problemAndonTypeIdInFilter : "",
    problemAndonSubtypeIdFilter : "",
    handleAndonTypeIdFilter : "",
    andonLightLevelIdFilter : "",
    stopWorkFilter : "",
    statusFilter : "",
    statusLtFilter : "",
    mstPositionIdFilter : "",
    mstPositionIdInFilter : "",
    mstLocationIdFilter : "",
    mstLocationIdInFilter : "",
    mstWorkCenterNameFilter : "",
    mstLocationCodeFilter : "",
    mstLocationNameFilter : "",
    projectCodeFilter : "",
    handleUserIdFilter : "",
    handleUserIdNameFilter : "",
    prdPpOperationIdFilter : "",
    startTimeRteFilter : "",
    startTimeLteFilter : "",
    finishTimeRteFilter : "",
    finishTimeLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'idFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.id',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.createdByName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'problemAndonTypeIdFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.problemAndonTypeId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesAndonType'
            ,showLabelSelectOne: true
                    ,selectFilter:{levelEqFilter:'.0.'}
        }
        },
        {
        key: 'stopWorkFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.stopWork',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '未响应' },
                { value: '2', text: '已响应' },
                { value: '3', text: '已超时' },
                { value: '4', text: '已完成' },
                { value: '5', text: '已撤销' }
            ]
        }
        },
        {
        key: 'mstWorkCenterNameFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.mstWorkCenterName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'mstLocationNameFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.mstLocationName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'handleUserIdNameFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.handleUserIdName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prdPpOperationIdFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.prdPpOperationId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.startTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.startTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'finishTimeRteFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.finishTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'finishTimeLteFilter',
        label: 'label.sith.andon.sithMesAndonTask.filter.finishTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'id',
        label: 'label.sith.andon.sithMesAndonTask.entity.id',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'problemAndonTypeName',
        label: 'label.sith.andon.sithMesAndonTask.entity.problemAndonTypeName',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonType'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"problemAndonTypeId":"id"}'
                }
        },
        {
        key: 'problemAndonSubtypeName',
        label: 'label.sith.andon.sithMesAndonTask.entity.problemAndonSubtypeName',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonType'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"problemAndonSubtypeId":"id"}'
                }
        },
        {
        key: 'handleAndonTypeName',
        label: 'label.sith.andon.sithMesAndonTask.entity.handleAndonTypeName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonType'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"handleAndonTypeId":"id"}'
                }
        },
        {
        key: 'startTime',
        label: 'label.sith.andon.sithMesAndonTask.entity.startTime',
        sortable: true,
        disabled: true,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'stopWork',
        label: 'label.sith.andon.sithMesAndonTask.entity.stopWork',
        sortable: true,
        disabled: true,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'status',
        label: 'label.sith.andon.sithMesAndonTask.entity.status',
        sortable: true,
        disabled: true,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '未响应' },
                { value: '2', text: '已响应' },
                { value: '3', text: '已超时' },
                { value: '4', text: '已完成' },
                { value: '5', text: '已撤销' }
            ]
        }
        },
        {
        key: 'expireNotice',
        label: 'label.sith.andon.sithMesAndonTask.entity.expireNotice',
        sortable: true,
        disabled: true,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'mstPositionName',
        label: 'label.sith.andon.sithMesAndonTask.entity.mstPositionName',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonType'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstPositionId":"id"}'
                }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.andon.sithMesAndonTask.entity.mstLocationName',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
        {
        key: 'handleUserIdLoginName',
        label: 'label.sith.andon.sithMesAndonTask.entity.handleUserIdLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"handleUserId":"id"}'
                }
        },
        {
        key: 'prdPpOperationName',
        label: 'label.sith.andon.sithMesAndonTask.entity.prdPpOperationName',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"prdPpOperationId":"operationSeq"}'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.andon.sithMesAndonTask.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'problemDescription',
        label: 'label.sith.andon.sithMesAndonTask.entity.problemDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'handleDescription',
        label: 'label.sith.andon.sithMesAndonTask.entity.handleDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'responseTime',
        label: 'label.sith.andon.sithMesAndonTask.entity.responseTime',
        sortable: true,
        disabled: true,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'finishTime',
        label: 'label.sith.andon.sithMesAndonTask.entity.finishTime',
        sortable: true,
        disabled: true,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'problemAttachmentList',
        label: 'label.sith.andon.sithMesAndonTask.entity.problemAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'problemAttachment'
                }
        },
        {
        key: 'handleAttachmentList',
        label: 'label.sith.andon.sithMesAndonTask.entity.handleAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'handleAttachment'
                }
        }
]

export {SithMesAndonTask, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs

, dispatchVoConfigs, executeVoConfigs
}
